import { useEffect, useRef, useState } from 'react'

interface ForbiddenErrorDetail {
  status: number
  text: string
}

interface SetErrorEvent extends CustomEvent<ForbiddenErrorDetail> {
  type: 'setError'
}

export const useForbiddenErrorListener = () => {
  const [hasForbiddenError, setHasForbiddenError] = useState(false)
  const [text, setText] = useState<string>('')
  const shouldIgnoreNextForbiddenRef = useRef(false)

  useEffect(() => {
    const handleSetError = (event: Event) => {
      const { detail } = event as SetErrorEvent

      if (shouldIgnoreNextForbiddenRef.current && detail?.status === 403) {
        shouldIgnoreNextForbiddenRef.current = false
        return
      }

      if (detail?.status === 403) {
        setHasForbiddenError(true)
        setText(detail.text)
      }
    }

    const handleResetError = () => {
      shouldIgnoreNextForbiddenRef.current = true
      setHasForbiddenError(false)
      setText('')
    }

    document.addEventListener('setError', handleSetError)
    document.addEventListener('resetError', handleResetError)

    return () => {
      document.removeEventListener('setError', handleSetError)
      document.removeEventListener('resetError', handleResetError)
    }
  }, [])

  return { hasForbiddenError, text }
}
